/** @format */

import axios from "axios";
import { BASE_URL } from "../Host";

//get all user
export const GetUsers = async (adminToken, params) => {
	try {
		
		const res = await axios.get(BASE_URL + `admin/user/getAllUsers`, {
			headers: {
				"x-access-token": `${adminToken}`,
				"Content-Type": "multipart/form-data",
			},
			
		});

		return res;
	} catch (error) {
		// Handle error if needed
		console.error("Error fetching users:", error);
		throw error;
	}
};

export const GetProfessionals = async (adminToken, params) => {
	const { page, limit, sortBy } = params;
	try {
		const res = await axios.get(BASE_URL + `admin/users/list/7`, {
			headers: {
				"x-access-token": `${adminToken}`,
				"Content-Type": "multipart/form-data",
			},
			params: {
				page: page,
				limit: limit,
				sortBy: sortBy,
			},
		});

		return res;
	} catch (error) {
		// Handle error if needed
		console.error("Error fetching users:", error);
		throw error;
	}
};

//get userby id
export const GetUserById = async (id) => {
	return await axios.get(BASE_URL + `admin/users/getUserById/${id}`);
};



//admin add user
export const CreateUser = async (data) => {
	return await axios.post(`${BASE_URL}admin/user/createUser`, data, {
		headers: {
			"Content-Type": "application/json",
			"x-access-token": `${localStorage.getItem("adminToken")}`,
		},
	});
};
//delete user
export const DeleteUser = async (user_id) => {
	return await axios.post(
		`${BASE_URL}admin/user/deleteUser`,
		{ user_id: user_id },
		{
			headers: {
				"x-access-token": `${localStorage.getItem("adminToken")}`,
				"Content-Type": "multipart/form-data",
			},
		}
	);
};

